import { Location } from "./data-models";
export class PointOfInterest {
    Id: number;
    CreationDate: Date;
    DisplayedDescription: string;
    DisplayedName: string;
    ExpiryDate: any;
    LastModifyDate: Date;
    LocalNameDescription: any[];
    Location: any;
    StartDate: any;
    Type: number;
    GeofenceCreation: boolean = false;
    Attachments: any[];
    BufferSize: number;
    isDelete: boolean = false;
    CreatedBy: number;
    LastModifiedBy: number;
    LocationChanged: boolean = false;
    AutoCreated: boolean = false;
    POIAssignedBranchId: number;
    PoiCode: string;
}

export class POIObjectView {
    Id: number;
    Location:Location;
    ViewName: string;
   
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/dataModels/poi.ts